import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtcOffsetPipe } from './utcOffset.pipe';
import { RpDatePickerComponent } from './date-picker/date-picker.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		FlexLayoutModule,
	],
	declarations: [UtcOffsetPipe, RpDatePickerComponent],
	exports: [UtcOffsetPipe, RpDatePickerComponent],
})
export class DateTimeModule {}
